import React, { useState, useEffect } from "react";
import Headerfile from "../../common/Headerfile";
import { Box, Select } from "@sainsburys-tech/fable";
import Footerfile from "../../common/Footerfile";
import { useGetPostsQuery } from "../../../api/apiConfig";
import styles from "./ErrorCode.module.css";
import { getLogisticsRole } from "../../../utils/authToken";
import { USER_ROLE } from "../../../constants/roles";
import Unauthorized from "../../unauthorized/Unauthorized";

const ErrorCode = () => {
  interface PrinterModel {
    Id?: string;
    PrinterModelId?: string;
    Name: string;
  }

  const [printerModel, setPrinterModel] = useState<PrinterModel[]>([]);

  function toSentenceCase(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const {
    isLoading: isPrinterModelLoading,
    isSuccess: isPrinterModelSuccess,
    data: printerModelList,
    refetch
  } = useGetPostsQuery("printer-models");

  const [selectedPrinterName, setSelectedPrinterName] = useState("");
  const [selectedPrinter, setSelectedPrinter] = useState("");

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (isPrinterModelSuccess && printerModelList?.Model) {
      const printerModels = [...(printerModelList.Model as PrinterModel[])];
      const sortedPrinterModels = printerModels.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setPrinterModel(sortedPrinterModels);
    }
  }, [isPrinterModelSuccess, printerModelList]);

  const handlePrinterModelChange = (value: string) => {
    const selectedOption = printerModel.find((model) => model.Name === value);
    setSelectedPrinterName(selectedOption ? selectedOption.Name : "");
    setSelectedPrinter(
      selectedOption
        ? selectedOption.PrinterModelId ?? selectedOption.Id ?? ""
        : ""
    );
  };

  const { data: errorCodeData } = useGetPostsQuery(
    `PrinterErrorCodes/ModelId?ModelId=${
      selectedPrinter !== "" ? selectedPrinter : ""
    }`
  );

  const loggedUserRole = getLogisticsRole();

  const isDisabled =
    loggedUserRole?.includes(USER_ROLE.ADMIN) ||
    loggedUserRole?.includes(USER_ROLE.READ_WRITE) ||
    loggedUserRole?.includes(USER_ROLE.READ_ONLY)
      ? false
      : true;

  return (
    <div className={styles.Container}>
      <Headerfile />
      {isDisabled ? (
        <Unauthorized />
      ) : (
        <Box className={styles.box}>
          <h5 className="text-center">Printer Error Code Descriptions</h5>
          <Select
            className={styles.Select}
            label="Printer Model"
            options={[
              { label: "Select Printer Model", value: "default" },
              ...(isPrinterModelLoading
                ? [
                    {
                      label: "Loading...",
                      value: "loading",
                      isDisabled: isPrinterModelLoading
                    }
                  ]
                : printerModel?.map((Model) => ({
                    label: Model?.Name,
                    value: Model.Name,
                    id: Model?.PrinterModelId ?? Model?.Id
                  })))
            ]}
            style={{ textAlign: "left" }}
            name="Identity.PrinterModel.Name"
            onChange={(value) => handlePrinterModelChange(value)}
          />
          <br />
          <h5
            style={{
              textAlign: "left",
              height: "100%",
              fontWeight: "500"
            }}
          >
            Printer Model: {selectedPrinterName}
          </h5>
          {selectedPrinter !== "" ? (
            <table className="table table-striped table-borderless">
              <thead>
                <tr>
                  <th>Response Code</th>
                  <th>Response message details</th>
                </tr>
              </thead>

              <tbody>
                {errorCodeData && errorCodeData?.Model?.length > 0 ? (
                  errorCodeData?.Model?.map((item: any, index: any) => (
                    <tr>
                      <td>{item?.ErrorCode}</td>
                      <td>{toSentenceCase(item?.ErrorDesc)}</td>
                    </tr>
                  ))
                ) : (
                  <tr className={styles.dataNotFound}>
                    <td colSpan={14} className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <div className={styles.printerNotSelected}>
              Please choose a printer model
            </div>
          )}
        </Box>
      )}
      <Footerfile />
    </div>
  );
};

export default ErrorCode;
